import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { Occasion, OccasionKind } from './occasions.types'

export interface OccasionIndexQueryKeyEntries {
  organizationId: OrganizationId
  kind?: OccasionKind | undefined
}

export async function getOccasions({
  queryKey: [{ organizationId, kind }],
}: Pick<QueryFunctionContext<[OccasionIndexQueryKeyEntries]>, 'queryKey'>) {
  return (
    (await axios.get<Occasion[]>(
      '/occasions',
      buildAdminRequestConfig({
        organizationId,
        params: kind ? { kind } : undefined,
      })
    )) || []
  )
}
